<template>
  <form id="profile-edit-form">
    <div class="form-group" v-if="showSuccess">
      <div class="alert alert-success msgblock">
        {{ formSuccess }}
      </div>
    </div>

    <div class="heading-bordered heading-account">
      <h2><span>Your Account Info</span></h2>
      <div class="alert alert-info" role="alert">
      <p><strong>NOTE:</strong> Make sure to save any changes to your account info before leaving the page.</p>
      </div>
    </div>


    

    <div class="form-group row">
      <!-- Primary Email -->
      <div class="col-xs-12 col-md-6">
        <label for="primary_email">Account Email</label>
        <input id="primary_email" name="primary_email" type="username" autocomplete="email" v-validate="'required'" v-model="tempProfileData.primary_email" class="form-control" :style="(errors.has('primary_email') && showFieldErrors) ? 'box-shadow: 0 0 8px red;border-radius: 5px;' : ''" :placeholder="profileData.primary_email" :disabled="profileData.primary_email">
        <span v-show="errors.has('primary_email') && showFieldErrors" class="text-danger">
          Please enter a valid email address
        </span>
      </div>
      <!-- Contact Email -->
      <div class="col-xs-12 col-md-6">
        <label for="contact_email">Contact Email</label>
        <input id="contact_email" name="contact_email" type="email" autocomplete="email" v-model="profileData.contact_email" v-validate="'required'" class="form-control" :style="(errors.has('contact_email') && showFieldErrors) ? 'box-shadow: 0 0 8px red;border-radius: 5px;' : ''" :placeholder="profileData.contact_email">
        <span v-show="errors.has('contact_email') && showFieldErrors" class="text-danger">
          Please enter a valid email address
        </span>
      </div>
    </div>

    <div class="form-group row">
      <!-- Contact First Name -->
      <div class="col-xs-12 col-md-4">
        <label for="given_name">Contact First Name</label>
        <input type="text" name="given-name" autocomplete="given-name" v-model="profileData.name.given_name" class="form-control" :placeholder="profileData.given_name">
      </div>
      <!-- Contact Last Name -->
      <div class="col-xs-12 col-md-4">
        <label for="given_name">Contact Last Name</label>
        <input type="text" name="family-name" autocomplete="family-name" v-model="profileData.name.family_name" class="form-control" :placeholder="profileData.name.family_name">
      </div>
      <!-- Fax Number -->
      <div class="col-xs-12 col-md-4">
        <label for="fax_number">Fax Number</label>
        <input id="fax_number" type="tel" name="tel-fax" v-model="profileData.fax_number" class="form-control" :placeholder="profileData.fax_number" autocomplete="tel-fax">
      </div>
    </div>

    <div class="form-group row">
      <!-- California Tax Exemption Number -->
      <div class="col-xs-12 col-md-4">
        <label for="tax_exempt_nos">Tax Exemption Number</label>
        <input id="tax_exempt_no" type="text" name="tax-exempt-no" v-model="profileData.tax_exempt_no" class="form-control" :placeholder="profileData.tax_exempt_no" autocomplete="tax-exempt-no">
      </div>
    </div>


    <div class="heading-bordered heading-account">
      <h2><span>Your Business Info</span></h2>
      <div class="alert alert-info" role="alert">
      <p><strong>NOTE:</strong> If you're a certified applicator then "your business info" can only be modified by NIC. To change, please contact us via phone or email.</p>
      </div>
    </div>

    <!-- Company Info -->
    <div class="form-group row">
      <!-- Company Name -->
      <div class="col-xs-12 col-md-6">
        <label for="company_name">Business Name</label>
        <input id="company_name" name="organization" type="text" v-model="tempProfileData.company_name" class="form-control" maxlength="30" :placeholder="profileData.company_name" :disabled="isCertified" autocomplete="organization">
      </div>
      <!-- Billing (Private) Phone Number -->
      <div class="col-xs-12 col-md-6">
        <label for="primary_phone_number">Billing Phone</label>
        <input id="primary_phone_number" type="tel" name="tel" autocomplete="tel" v-model="tempProfileData.primary_phone" class="form-control" :placeholder="profileData.primary_phone" :disabled="isCertified">
      </div>
    </div>

    <div class="form-group row">
      <!-- Address 1 -->
      <div class="col-xs-12 col-md-6">
        <label for="company_address_1">Address</label>
        <input type="text" name="address-line1" autocomplete="address-line1" v-model="profileData.company_address.street_address" class="form-control" :placeholder="profileData.company_address.street_address" :disabled="isCertified">
      </div>
      <!-- Address 2 -->
      <div class="col-xs-12 col-md-6">
        <label for="company_address_2">Address 2</label>
        <input type="text" name="address-line2" autocomplete="address-line2" v-model="profileData.company_address.street_address_2" class="form-control" :placeholder="profileData.company_address.street_address_2" :disabled="isCertified">
      </div>
    </div>

    <div class="form-group row" v-if="hasAddress">
      <!-- Country -->
      <div class="col-xs-12 col-md-6">
        <label for="country">Country</label>
        <span class="styled-select">
          <select name="country" id="countryCode" v-model="profileData.company_address.country.code" class="form-control" @change="updatedCountry()" :disabled="isCertified">
            <option value="" disabled selected>Country</option>
            <option value="USA">United States</option>
            <option value="CAN">Canada</option>
            <option disabled>--------------</option>
            <option v-for="(country, index) in countries" :value="country.code" :key="index">
              {{ country.long_name }}
            </option>
          </select>
        </span>
      </div>
      <!-- State/Region -->
      <div class="col-xs-12 col-md-6">
        <label for="state">State/Region</label>
        <span class="styled-select">
          <select name="address-level1" type="text" autocomplete="address-level1" v-model="profileData.company_address.region.code" class="form-control" :disabled="!stateRequired && isCertified">
            <option value="" disabled selected>State/Region</option>
            <option :value="profileData.company_address.region.code">{{ profileData.company_address.region.name }}</option>
            <option v-for="(region, index) in regions" :value="region.code" :key="index">
              {{ region.name }}
            </option>
          </select>
        </span>
      </div>
    </div>

    <div class="form-group row">
      <!-- City -->
      <div class="col-xs-12 col-md-6">
        <label for="city">City</label>
        <input name="address-level2" type="text" autocomplete="address-level2" v-model="profileData.company_address.city" class="form-control" :placeholder="profileData.company_address.city" :disabled="isCertified">
      </div>
      <!-- Postal Code -->
      <div class="col-xs-12 col-md-6">
        <label for="postal_code">Postal Code</label>
        <input type="text" name="postal-code" autocomplete="postal-code" maxlength="10" v-model="profileData.company_address.postal_code" class="form-control" :placeholder="profileData.company_address.postal_code" :disabled="isCertified">
      </div>
    </div>

    <div class="form-group">
      <div class="alert alert-danger color-error msgblock" v-if="showError">
        {{ formError }}
      </div>
    </div>

    <br>
    <hr>

    <div class="row">
      <div class="col-sm-6">
        <button type="button" @click="resetModalOpen" class="btn btn-block btn-blue">
          Change Password
        </button>
      </div>
      <div class="col-sm-6">
        <button :disabled="submitting" type="button" @click.prevent="updateProfile" class="btn btn-block btn-blue">
          <i class="fa fa-spin fa-spinner" v-if="submitting"></i> Save Changes
        </button>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapMutations } from 'vuex';
  import countries from '../../mixins/countries';

  export default {
    name: 'profile-edit-form',

    props: {
      isLoggedIn: Boolean,
      me: Object
    },

    mixins: [countries],

    data() {
      return {
        profileData: new Form({
          name: '',
          contact_email: '',
          primary_email: '',
          company_name: '',
          company_phone: '',
          primary_phone: '',
          fax_number: '',
          about: '',
          business_hours: '',
          website: '',
          facebook_url: '',
          instagram_url: '',
          company_address: '',
          tax_exempt_no: '',
        }),
        tempProfileData: new Form({
          primary_email: '',
          company_name: '',
          primary_phone: '',
        }),
        badges: '',
        countries: [],
        regions: [],
        stateRequired: false,
        formSuccess: '',
        showSuccess: false,
        formError: '',
        showError: false,
        showFieldErrors: false,
        submitting: false,
      };
    },

    mounted() {
      let vm = this;
      vm.getCountries();
      vm.setUserData();
    },

    watch: {
      isLoggedIn() {
        this.setUserData();
      },
    },

    computed: {
      hasPrimaryPhone() {
        return !!this.profileData.primary_phone;
      },
      hasPrimaryEmail() {
        return !!this.profileData.primary_email;
      },
      hasContactEmail() {
        return !!this.profileData.contact_email;
      },
      hasBusinessName() {
        return !!this.profileData.company_name;
      },
      hasAddress() {
        return !!this.profileData.company_address.street_address;
      },
      patchFriendlyAddress() {
        const address = this.profileData.company_address;

        return {
          city: address.city || null,
          company: address.company || null,
          country_code: address.country.code || '',
          region_code: address.region.code || '',
          postal_code: address.postal_code.replace(/_/g, '') || null,
          street_address: address.street_address || null,
          street_address_2: address.street_address_2 || null,
          type: 'company',
        };
      },
      isCertified() {
        return (
          this.badges.includes('certified') || this.badges.includes('distributor') &&
          !this.profileData.company_address.length
        );
      }
    },

    methods: {
      ...mapMutations(["setMe"]),

      setUserData() {
        if (this.isLoggedIn) {
          this.profileData = new Form({
            name: this.me.name,
            contact_email: this.me.contact_email,
            primary_email: this.me.primary_email,
            company_name: this.me.company_name,
            primary_phone: this.me.primary_phone,
            company_phone: this.me.company_phone,
            fax_number: this.me.fax_number,
            about: this.me.about,
            business_hours: this.me.business_hours,
            website: this.me.website,
            facebook_url: this.me.facebook_url,
            instagram_url: this.me.instagram_url,
            company_address: this.me.company_address.length ? this.me.company_address : this.me.primary_address,
            tax_exempt_no: this.me.tax_exempt_no,
          });
          this.badges = this.me.badges;
          this.$emit('set-is-certified', this.isCertified);
        }
      },
      hasValidAddress() {
        const hasAddressFields = Object.keys(
          this.profileData.company_address
        ).some((k) => k != null);

        if (!hasAddressFields) return false;

        return !(
          this.profileData.company_address.street_address == null ||
          this.profileData.company_address.city == null ||
          this.profileData.company_address.postal_code == null ||
          this.profileData.company_address.country.code == null ||
          this.profileData.company_address.region.code == null
        );
      },
      resetModalOpen() {
        this.$root.currentModalView = 'userReset';
        $("#login").modal("show");
      },
      normalizeUrl(target, url) {
        if (url != null) {
          if (url.substring(0, 7) === 'http://') {
            this.profileData[target] = url.substring(7);
          } else if (url.substring(0, 8) === 'https://') {
            this.profileData[target] = url.substring(8);
          }
        }
      },
      async updateProfile() {
        this.submitting = true;
        this.normalizeUrl('website', this.profileData.website);
        this.normalizeUrl('facebook_url', this.profileData.facebook_url);
        this.normalizeUrl('instagram_url', this.profileData.instagram_url);

        let hasError = false;
        let payload = {
          name: this.profileData.name,
          contact_email: this.profileData.contact_email,
          company_phone: this.profileData.company_phone,
          fax_number: this.profileData.fax_number,
          about: this.profileData.about,
          business_hours: this.profileData.business_hours,
          website: this.profileData.website,
          instagram_url: this.profileData.instagram_url,
          facebook_url: this.profileData.facebook_url,
          tax_exempt_no: this.profileData.tax_exempt_no,
        };

        if (!this.hasPrimaryPhone) {
          payload['primary_phone'] = this.tempProfileData.primary_phone;
        }

        if (this.hasValidAddress() && !this.hasAddress) {
          payload['company_address'] = this.patchFriendlyAddress;
        }

        if (this.tempProfileData.company_name && !this.hasBusinessName) {
          payload['company_name'] = this.tempProfileData.company_name;
        }

        if (this.hasContactEmail) {
          try {
            const success = await this.$validator.validateAll();

            if (success) {
              payload['contact_email'] = this.profileData.contact_email;
            } else {
              hasError = true;
              this.showError = true;
              this.formError = this.errors?.items.find(err => err.field == 'contact_email').msg;
            }
          } catch (error) {
            hasError = true;
          }
        }

        if (!this.hasPrimaryEmail && this.tempProfileData.primary_email) {
          try {
            const success = await this.$validator.validateAll();

            if (success) {
              payload['primary_email'] = this.tempProfileData.primary_email;
            } else {
              hasError = true;
              this.showError = true;
              this.formError = this.errors?.items.find(err => err.field == 'primary_email').msg;
            }
          } catch (error) {
            hasError = true;
          }
        }

        if (hasError) {
          this.submitting = false;
          this.showFieldErrors = true;
          return;
        }

        const hasAddressFields = Object.keys(
          this.profileData.company_address
        ).some((k) => k != null);

        if (
          hasAddressFields &&
          !this.hasValidAddress() &&
          !this.hasAddress &&
          this.isCertified
        ) {
          this.formError = 'Please fill all address fields.';
          let vm = this;
          vm.showError = true;
          this.submitting = false;

          setTimeout(function () {
            vm.showError = false;
          }, 3000);
        } else {
          try {
            const response =  await axios.patch(`/api/proxify/me`, payload);
            this.submitting = false;
            this.setMe(response.data);
            localStorage.setItem("user", JSON.stringify(response.data));
          } catch (error) {
            console.error(error);
            this.formError = 'Could not update profile.';
            let vm = this;
            vm.showError = true;
            this.submitting = false;

            setTimeout(function () {
              vm.showError = false;
            }, 3000);
          }
        }
      },
      isStateRequired(countryCode) {
        const code = countryCode;
        this.stateRequired = ['CAN', 'USA', 'JAM', 'IND', 'AUS'].includes(code);
      },
      updatedCountry() {
        this.isStateRequired(this.profileData.company_address.country.code);
        if (this.stateRequired) {
          let regionsUrl =
            '/api/proxify/domains/cerakote/shop/countries/' +
            this.profileData.company_address.country.code +
            '/regions';
          //this.stateRequired = true;
          axios
            .get(regionsUrl)
            .then(({ data: response }) => {
              this.regions = response;
            })
            .catch((response) => {
              console.log(response);
            });
        } else {
          this.profileData.company_address.region.code = ''; // If user has switched from a country where state is required to non required then remove the previously filled value
        }
      },
      addPhone() {
        this.profileData.phones.push({ value: '' });
      },
      deletePhone(index) {
        Vue.delete(this.profileData.phones, index);
      },
      primaryPhone(phone, index) {
        if (phone.is_primary) {
          return;
        }

        this.profileData.phones = this.profileData.phones.map(function (item) {
          item.is_primary = false;
          return item;
        });

        for (const formPhone of this.profileData.phones) {
          if (formPhone.value === phone.value) {
            formPhone.is_primary === true;
          }
        }
        // Mark this as primary
        phone.is_primary = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  #profile-edit-form {
    padding-top: 20px;
  }
</style>